import { render, staticRenderFns } from "./admin-item-single-main.vue?vue&type=template&id=1eac03ea&"
import script from "./admin-item-single-main.vue?vue&type=script&lang=js&"
export * from "./admin-item-single-main.vue?vue&type=script&lang=js&"
import style0 from "./admin-item-single-main.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports